module.exports = __webpack_public_path__ + "images/emoji/oncoming_taxi.4908dedcd048b9d82adb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/oncoming_taxi.png
// module id = lz7f
// module chunks = 2